import React, { useEffect, useState } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="w-full px-4 py-16 md:py-20" data-id="element-377">
      <div className="max-w-4xl mx-auto" data-id="element-378">
        <div className="bg-gradient-to-br from-red-500/20 to-orange-500/20 border-2 border-red-500 rounded-2xl p-6 md:p-10" data-id="element-379">
          <div className="flex flex-col items-center justify-center gap-4 mb-8" data-id="element-380">
            <AlertTriangleIcon className="w-8 h-8 text-red-400" data-id="element-381" />
            <h2 className="text-2xl md:text-4xl font-bold text-white text-center leading-tight" data-id="element-382">
              Oferta Limitada — El reloj está corriendo
            </h2>
          </div>
          <div className="flex justify-center gap-2 md:gap-4 mb-8" data-id="element-383">
            <div className="bg-slate-900 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] text-center" data-id="element-384">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-385">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <div className="text-xs md:text-sm text-gray-400" data-id="element-386">HORAS</div>
            </div>
            <div className="flex items-center text-2xl md:text-3xl font-bold text-white" data-id="element-387">
              :
            </div>
            <div className="bg-slate-900 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] text-center" data-id="element-388">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-389">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <div className="text-xs md:text-sm text-gray-400" data-id="element-390">MINUTOS</div>
            </div>
            <div className="flex items-center text-2xl md:text-3xl font-bold text-white" data-id="element-391">
              :
            </div>
            <div className="bg-slate-900 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] text-center" data-id="element-392">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-393">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <div className="text-xs md:text-sm text-gray-400" data-id="element-394">SEGUNDOS</div>
            </div>
          </div>
          <div className="space-y-4 text-center" data-id="element-395">
            <p className="text-base md:text-xl text-gray-200" data-id="element-396">
              La IA evoluciona rápido.
            </p>
            <p className="text-base md:text-xl text-gray-200" data-id="element-397">
              Pronto actualizaremos el sistema y subiremos el precio.
            </p>
            <p className="text-sm md:text-lg text-gray-300" data-id="element-398">
              Cuanto antes entres, antes empezarás a crecer mientras otros
              siguen adivinando.
            </p>
          </div>
        </div>
      </div>
    </section>;
}